import onDomContentLoaded from '../../utilities/onDomContentLoaded';
import ErrorBoundary from '../../components/ErrorBoundary';
import '../../../scss/pages/opt-out/main.scss';
import { setOptOutCookie } from '../../utilities/optout-cookie';
import PrivacySnackBar from './components/privacy-snackbar';
import { trackEDDL, ANALYTICS_CONSTANTS } from '../../utilities/analytics';
import { ITrackingPayload } from '../../types/analytics';
import EmailOptOutField from './components/EmailOptOutField';
import { createRoot } from 'react-dom/client';

const CookieOptOutButton = () => {
    return (
        <>
            <PrivacySnackBar />
        </>
    );
};

function startUp() {
    const textFieldRoot = document.getElementById('hm-text-field-opt-out__root');
    const snackBarContainer = document.getElementById('cookie-opt-out-root');

    if (snackBarContainer) {
        const root = createRoot(snackBarContainer);
        root.render(
            <ErrorBoundary>
                <CookieOptOutButton />
            </ErrorBoundary>,
        );
    }

    if (textFieldRoot) {
        const root = createRoot(textFieldRoot);
        root.render(
            <ErrorBoundary>
                <EmailOptOutField />
            </ErrorBoundary>,
        );
    }

    const payload: ITrackingPayload = {
        event: ANALYTICS_CONSTANTS.EVENTS.CLICK.CTA,
        linkDetails: {
            name: 'CLICK HERE FOR EMAIL OPT-OUT',
            position: 'OptOut',
        },
    };

    const form = document.getElementById('doNotSellForm');

    if (form != null) {
        form.addEventListener('submit', (e) => {
            if (form != null && form.classList.contains('is-submitting')) {
                e.preventDefault();
            }

            const trigger = document.getElementById('opt-out-email-trigger');
            if (trigger != null) {
                trigger.setAttribute('disabled', 'true');
            }

            if (typeof setOptOutCookie === 'function') {
                setOptOutCookie();
                trackEDDL(payload);
            }
        });
    }
}

onDomContentLoaded(() => {
    startUp();
});
